<template>
  <div class="user-wrap">
    <div class="left">
      <img src="./logo_icon.svg" alt="" srcset="" />
    </div>
    <div class="right">
      <div class="right-content">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.user-wrap {
  display: flex;
  width: 100%;
  height: 100%;

  .left {
    width: 480px;
    background: url('./side-banner.jpg') no-repeat;
    background-size: cover;
    color: #fff;
    img {
      display: block;
      margin: 85px auto 105px 54px;
    }
    span {
      display: block;
      padding-top: 48px;
      font-size: 18px;
      font-weight: 400;
      margin-left: 46px;
    }
  }
  .right {
    flex: 1;
    width: 100%;
    overflow-y: auto;

    .right-content {
      width: 650px;
      margin: 125px auto 0;
    }

    .user-input {
      height: 54px;
    }

    .user-label {
      font-size: 16px;
      color: #3a3f63;
      line-height: 24px;
      font-weight: 400;
    }

    .submit-btn {
      width: 240px;
      font-family: Rubik-Regular;
      font-size: 14px;
      font-weight: 400;
    }
  }
}
</style>
